import RootStore from './Root';

export default new RootStore();
